export enum InventoryEventTabs {
  Info = 'info',
  Tags = 'tags',
  SellThroughRate = 'sellThroughRate',
  ManualPricing = 'manualPricing',
  Transactions = 'transactions',
  Fulfillment = 'fulfillment',
  FulfillmentRules = 'fulfillmentRules',
  Dashboard = 'dashboard',
  Boost = 'boost',
  EditMap = 'editMap',
  PricingABTest = 'pricingABTest',
  None = 'none',
  EventDiscovery = 'eventDiscovery',

  // Mobile tabs
  Mobile_Sales = 'mobileSales',
  Mobile_Purchases = 'mobilePurchases',
  Mobile_Notes = 'mobileNotes',
}
